export class Category {
    constructor(
        public id: number,
        public slug: string,
        public name: string,
        public link: string
      ) {}
}
